// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_WHgk6 {
  display: flex;
  height: 93vh;
  margin: 0;
  padding: 0;
  background-color: var(--white-background);
  font-family: "Inter", serif;
  position: relative;
}

.inputContainer_E35LD input[type="file"] {
  display: none;
}
.inputContainer_E35LD {
  width: 100%;
}
.inputContainer_E35LD label {
  height: 100%;
  width: 100%;
  color: #646e8a;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/InvoicePanel/InvoicePanel.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.container {\n  display: flex;\n  height: 93vh;\n  margin: 0;\n  padding: 0;\n  background-color: var(--white-background);\n  font-family: \"Inter\", serif;\n  position: relative;\n}\n\n.inputContainer input[type=\"file\"] {\n  display: none;\n}\n.inputContainer {\n  width: 100%;\n}\n.inputContainer label {\n  height: 100%;\n  width: 100%;\n  color: #646e8a;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_WHgk6`,
	"inputContainer": `inputContainer_E35LD`
};
export default ___CSS_LOADER_EXPORT___;
